/* tslint:disable */
/* eslint-disable */
export enum PrebidCreditExecutionMode {
  CheckRemainingCredit = 'check_remaining_credit',
  IgnoreRemainingCredit = 'ignore_remaining_credit'
}
